import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=1f6a7cbe&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=1f6a7cbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6a7cbe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f6a7cbe')) {
      api.createRecord('1f6a7cbe', component.options)
    } else {
      api.reload('1f6a7cbe', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=1f6a7cbe&scoped=true&", function () {
      api.rerender('1f6a7cbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-41eEIz398RefR/JS/comp/PopupBox.vue"
export default component.exports